module.exports = __webpack_public_path__ + "img/index-service@2x.fef40df3.png";